import { createUseStyles } from 'react-jss';
import { color, spacing } from '@blink/components';

export const useRegisterMarginAccountStyle = createUseStyles({
    root: {
        minWidth: 500,
        color: color.content.primary,
        maxHeight: '450px',
        overflow: 'scroll',
        marginTop: spacing['07'],
        marginBottom: '40px',
        paddingRight: spacing['03'],
        maxWidth: 635,

        '& .ant-steps .ant-steps-item-finish .ant-steps-item-icon': {
            backgroundColor: `${color.content.brand500} !important`,
            borderColor: `${color.content.brand500} !important`,
        },

        '& .ant-steps .ant-steps-item-active .ant-steps-item-icon': {
            backgroundColor: `${color.content.brand500} !important`,
            borderColor: `${color.content.brand500} !important`,
        },

        '& .anticon': {
            color: color.content.inversePrimary,
        },

        '& .ant-steps-item-tail:after': {
            backgroundColor: `${color.content.brand500} !important`,
        },
    },
});
